import { useContext, useState } from "react";
import { MultiSetting } from "../../kashikabuttons";
import list_city from "../../citylist/list_city";
import { Area1Set, Area2Set } from "../../App";
import { Year1Set, Year2Set } from "../../App";
import { useParams } from "react-router-dom";
import list_gg_prefmap from "../../citylist/list_gg_prefmap.json";

// console.log(list_gg_prefmap);
const locationsetting = decodeURI(location.search).split("_");


const Prefbutton = ({ pref }) => {
  return (
    <>
      <button className="w-full h-full hover:bg-blue-700 py-2 px-4 rounded">
        {pref}
      </button>
    </>
  );
};

const Citybutton = ({ city }) => {
  return (
    <>
      <button className="w-full h-full bg-green-700 hover:bg-green-500 text-white py-2 px-4 rounded">
        {city}
      </button>
    </>
  );
};

export const Prefmap = ({ setPreftmp }) => {
  return (
    <>
      <svg className="geolonia-svg-map" viewBox="0 0 1000 1000">
        <g
          className="svg-map"
          transform="matrix(1.028807, 0, 0, 1.028807, -47.544239, -28.806583)"
        >
          <g className="prefectures" transform="matrix(1, 0, 0, 1, 6, 18)">
          {list_gg_prefmap.map((pref)=>{
  return (
          <g
            key = {pref.pref_name}
            onClick={() => setPreftmp(pref.pref_name)}
            className="hover:fill-blue-100"
            data-code={47}
            strokeLinejoin="round"
            fill={pref.gg_color}
            fillRule="nonzero"
            stroke="#000"
            strokeWidth={1.0}
            transform={`translate(${pref.transform1},${pref.transform2})`}
          >
            <title>{pref.pref_name}</title>
            <div id={pref.pref_name}></div>
            {pref.polyorpath ? <polygon points={pref.polpath} /> : <path d={pref.polpath} /> }
          </g>
          )
          })}
          </g>
          <g
            className="boundary-line"
            stroke="#EEE"
            strokeWidth={4}
            strokeLinejoin="round"
          >
            <line x1="320.227" y1="361.996" x2="582.351" y2="109.378" />
            <line x1="277.337" y1="380.162" x2="46.213" y2="380.162" />
          </g>
        </g>
      </svg>
    </>
  );
};

export function Modalcity0set({ show, setShow }) {
  const [preftmp, setPreftmp] = useState("");
  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);
  const { year1set, setYear1Set } = useContext(Year1Set);
  const { year2set, setYear2Set } = useContext(Year2Set);
  const params = useParams();

  const setArea0Set = (data) => {
    if (show == 1) {
      setArea1Set(data);
    } else if (show == 2) {
      setArea2Set(data);
    } else {
      setArea1Set(data);
      setArea2Set(data);
    }
    setPreftmp("");
    setShow(false);
  };

  const ZONES = [
    "北海道地方",
    "東北地方",
    "関東地方",
    "中部地方",
    "近畿地方",
    "中国四国地方",
    "九州地方",
    "日本全国",
  ];

  console.log(params.no);
  console.log(params.no2);


  if (show) {
    return (
      <>
        <div
          id="overlay"
          onClick={() => {setShow(false);setPreftmp("")}}
          className="flex items-center justify-center top-0 left-0 w-screen h-screen z-40 bg-white/30"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="h-screen overflow-y-auto z-80 bg-gradient-to-r from-black/90 via-black/80 to-black/90 w-5/6 mx-auto"
          >
            <div onClick={()=>setShow(false)} className="flex justify-end mt-2 mr-2 cursor-pointer text-white pointer-events-auto">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>


            <div>
                <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-4 py-8">
                  <div className="text-center pb-12">
                    <h2 className="text-base font-bold text-indigo-600"></h2>
                    {preftmp && (
                      <>
                        <div onClick={()=>setPreftmp("")} className="font-bold text-base md:text-base lg:text-xl font-heading text-gray-100 text-left cursor-pointer">
                          ＜戻る
                        </div>

                        <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl font-heading text-gray-100">
                          {preftmp}
                        </h1>
                      </>
                    )}


                    {!preftmp && (
                      <>
                        <div onClick={()=>setShow(false)} className="font-bold text-base md:text-base lg:text-xl font-heading text-gray-100 text-left cursor-pointer">
                          ＜戻る
                        </div>
                        <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl font-heading text-gray-100">
                        {params.mode !== "5" && <>都道府県を選択</>}
                        {params.mode === "5" && <>地方を選択</>}
                        </h1>
                      </>
                    )}
                  </div>


                  {params.mode !== "5" && !preftmp && (
                    <div>

                      <div>
                        <Prefmap setPreftmp={setPreftmp} />
                      </div>
                      <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 xl:grid-cols-8 gap-4 text-xs sm:text-sm md:text-base">

                        { list_gg_prefmap.map((pref)=>{
                          // console.log(pref.gg_color);
                          return (
                            <div
                              key = {pref.pref_name}
                              onClick={() => setPreftmp(pref.pref_name)}
                              // className={`bg-[pink] rounded`}
                              className={`bg-[lightgray] rounded`}
                              // className={`bg-[${pref.gg_color}] rounded`}
                            >
                              <Prefbutton
                                pref={pref.pref_name}
                                show={show}
                                setShow={setShow}
                              />
                            </div>
                            )
                        })
                        }
                      </div>
                    </div>
                  )}

                  {params.mode !== "5" && preftmp && (
                    <div className="text-black">
                      <div className="grid grid-cols-4 sm:grid-cols-6 lg:grid-cols-8 xl:grid-cols-8 gap-4 text-xs sm:text-sm md:text-base">
                        {list_city.map((data, index) => {
                          return (
                            data.value.startsWith(preftmp) && (
                            // data.value.includes(preftmp) && (
                              <div onClick={() => setArea0Set(data.value)} key={index}>
                                {show != 1 && show != 2 && (
                                  <MultiSetting
                                    modeset={data.value?.endsWith("地方") ? 5 : params.mode}
                                    // modeset={params.mode}
                                    area1set={data.value}
                                    area2set={data.value}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data.label} />
                                  </MultiSetting>
                                )}
                                {show == 1 && (
                                  <MultiSetting
                                    modeset={data.value?.endsWith("地方") ? 5 : params.mode}
                                    // modeset={params.mode}
                                    area1set={data.value}
                                    area2set={area2set}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data.label} />
                                  </MultiSetting>
                                )}
                                {show == 2 && (
                                  <MultiSetting
                                    modeset={data.value?.endsWith("地方") ? 5 : params.mode}
                                    // modeset={params.mode}
                                    area1set={area1set}
                                    area2set={data.value}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data.label} />
                                  </MultiSetting>
                                )}
                              </div>
                            )
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {params.mode === "5" && (
                    <div className="text-black">
                      <div className="grid grid-cols-4 sm:grid-cols-4 lg:grid-cols-8 xl:grid-cols-8 gap-4 text-xs sm:text-sm md:text-base">
                        {ZONES.map((data, index) => {
                          return (
                            data && (
                              <div onClick={() => setArea0Set(data)} key={index}>
                                {show != 1 && show != 2 && (
                                  <MultiSetting
                                    modeset={params.mode}
                                    area1set={data}
                                    area2set={data}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data} />
                                  </MultiSetting>
                                )}

                                {show == 1 && (
                                  <MultiSetting
                                    modeset={params.mode}
                                    area1set={data}
                                    area2set={area2set}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data} />
                                  </MultiSetting>
                                )}

                                {show == 2 && (
                                  <MultiSetting
                                    modeset={params.mode}
                                    area1set={area1set}
                                    area2set={data}
                                    year1set={year1set}
                                    year2set={year2set}
                                    no={params.no}
                                    no2={locationsetting[4]}
                                  >
                                    <Citybutton city={data} />
                                  </MultiSetting>
                                )}
                              </div>
                            )
                          );
                        })}
                      </div>
                    </div>
                  )}

                </section>
            </div>
            {!preftmp && (
              <div className="text-center w-full">
                <button
                  onClick={() => setShow(false)}
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800"
                >
                  <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    戻る
                  </span>
                </button>
              </div>
            )}
            {preftmp && (
              <div className="text-center w-full">
                <button
                  onClick={() => setPreftmp("")}
                  className="relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 overflow-hidden text-sm font-medium text-gray-900 rounded-lg group bg-gradient-to-br from-cyan-500 to-blue-500 group-hover:from-cyan-500 group-hover:to-blue-500 hover:text-white dark:text-white focus:ring-4 focus:ring-cyan-200 dark:focus:ring-cyan-800"
                >
                  <span className="relative px-5 py-2.5 transition-all ease-in duration-75 bg-white dark:bg-gray-900 rounded-md group-hover:bg-opacity-0">
                    戻る
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
